import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=565e2cab"
import script from "./Step.vue?vue&type=script&lang=js"
export * from "./Step.vue?vue&type=script&lang=js"
import style0 from "./Step.vue?vue&type=style&index=0&id=565e2cab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports